import React, { createContext, useContext, useEffect, useState } from "react";
import { getConfig } from "../api/configAPI";

const ConfigContext = createContext({
   config: {}
});

const useConfigContext = () => useContext(ConfigContext);

const ConfigContextProvider = props => {
    const [data, setData] = useState({
        config: {},
        loading: true,
        error: null
    });

    const {
        config,
        loading,
        error
    } = data;

    useEffect(() => {
        const mount = async () => {
            const configFromServer = await getConfig();
            if (configFromServer) {
                setData({
                    config: configFromServer,
                    loading: false,
                    error: null
                })
            } else {
                setData( {
                    config: {},
                    error: "Failed to load configuration",
                    loading: false
                });
            }
        }
        mount();
    },[])

    return (
        <ConfigContext.Provider value={{config}}>
            {loading ? <div>Loading...</div> : <>
                {
                    error ? <div>Error: {error}</div> : props.children
                }
            </>}
        </ConfigContext.Provider>
    );
}

export { ConfigContext, ConfigContextProvider, useConfigContext };